
const pageTextConfig = {
    sectionTitle: "Setup a payment method to recieve payments",
    enterUPIprompt: "Please enter your UPI ID",
    enterBankAccountDetailsprompt: "Please enter Bank Account Details",
    paymentAcknowledgement: "I acknowledge that the payment information I have entered is accurate and up-to-date. I understand that any errors or inaccuracies in the payment details mentioned above may result in incorrect transactions and that I am responsible for ensuring the correctness of the information provided."
}

export default pageTextConfig